import { useEffect } from "react";
import { APP_DOCUMENT_TITLE } from "../../constants";

const UseTitle = ({ formattedTitle }) => {
  useEffect(() => {
    document.title = formattedTitle || APP_DOCUMENT_TITLE;
  }, [formattedTitle]);

  return null;
};

export default UseTitle;
